class Binder {
    /**
     * Binder class, useful for times where you must remove events that were set with bound functions. Rather than
     * storing each of the bound functions, simply create an instance of Binder, and then when removing the listener,
     * retrive the bound function by calling instance.getBound(unboundCallback) with unboundCallback being
     * self-explanatory.
     */
    constructor(instance = null) {
        this.instance = instance;
        this.functions = [ ];
        this.bound = [ ];
    }
    
    func(func) {
        if (typeof func === 'string') {
            if ( ! this.instance) {
                throw new Error('Binder: Cannot resolve string function name, no instance passed' + func);
            }
            
            let strFunc = func;
            
            func = this.instance[func];

            if ( ! func) {
                throw new Error('Binder: Cannot resolve passed function: ' + strFunc);
            }
        }
        
        return func;
    }

    /**
     * Bind function.
     * 
     * @param {function|string} func - The function to bind. If a string, the equivalently named function from the
     * default bind instance passed on initial construction will be used.
     * @param args - Args to bind
     * @returns {function}
     */
    bind(func, ...args) {
        if (typeof func !== 'function' && typeof func !== 'string') {
            throw new Error('Binder.bind expects argument 1 to be of type "string" or "function"');
        }
        
        // func may be string, so resolve that first
        func = this.func(func);
        
        let bound = this.getBound(func);
        
        // Don't double bind
        if ( ! bound) {
            bound = func.bind.apply(func, [this.instance].concat(args));

            this.functions.push(func);
            this.bound.push(bound);
        }
        
        return bound;
    }
    
    getBound(func) {
        // func may be string, so resolve that first
        func = this.func(func);
        
        let index = this.functions.indexOf(func);
        
        if (index > -1) {
            return this.bound[index];
        }
        
        return null;
    }
    
    getUnbound(bound) {
        let index = this.bound.indexOf(bound);
        
        if (index > -1) {
            return this.functions[index];
        }
        
        return null;
    }
    
    destroy() {
        this.instance = null;
        this.functions = null;
        this.bound = null;
    }
}

export default Binder;